import { render, staticRenderFns } from "./Shutters_vue.vue?vue&type=template&id=3162e705&"
import script from "./Shutters_vue.vue?vue&type=script&lang=js&"
export * from "./Shutters_vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports